// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"_ba-z","subtitle":"aca-z","wrapper":"bca-z","leftArrow":"cca-z","rightArrow":"dca-z"};